import { render, staticRenderFns } from "./productFlags.vue?vue&type=template&id=eebd5262&scoped=true&"
import script from "./productFlags.vue?vue&type=script&lang=js&"
export * from "./productFlags.vue?vue&type=script&lang=js&"
import style0 from "./productFlags.vue?vue&type=style&index=0&id=eebd5262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebd5262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
